<template>
  <section class="promo--detail-banner">
    <picture>
      <source :srcset="banner.image" type="image/webp" />
      <source :srcset="getFallbackImage(banner.image)" type="image/jpeg" />
      <img :src="getFallbackImage(banner.image)" :alt="`${banner.title} - BeliRumah`" />
    </picture>
  </section>
</template>

<script>
import HelperMixin from '@/mixins/helpers';

export default {
  name: 'banner-detail',
  mixins: [HelperMixin],
  props: ['banner'],
};
</script>
